var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'button',_vm.$attrs,false),[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }